/** Service Desk console: ang CSV import wizard sa Service settings (C22, SD-S1-50): upload, i-map ang mga column, i-validate (dry run), tapos na. */
export const serviceImport = {
  nav: "Import",
  title: "Import",
  subtitle: "Ipasok ang mga organisasyon at contact mula sa spreadsheet. Sinusuri namin ang bawat hanay bago mag-save ng kahit ano.",
  stepsLabel: "Mga hakbang sa import",
  stepCompleted: "(tapos na)",
  stepHeading: "Hakbang {{n}} sa 4 · {{name}}",
  steps: { upload: "I-upload", map: "I-map ang mga column", validate: "I-validate", done: "Tapos na" },
  kinds: { organisations: "Mga Organisasyon", contacts: "Mga Contact", tickets: "Mga lumang ticket", sites: "Mga Site", assets: "Mga Asset", products: "Mga Produkto" },
  kindHint: {
    organisations: "Itinutugma sa external id, display code, tapos pangalan",
    contacts: "Itinutugma sa e-mail",
    tickets: "Mga lumang ticket, itinutugma sa id nila sa lumang sistema",
    sites: "Mga site ng kliyente mula sa CSV file",
    assets: "Mga naka-install na kagamitan mula sa CSV file",
    products: "Mga produkto ng catalogue mula sa CSV file",
  },
  kindGroup: "Ano ang ii-import mo?",
  upload: {
    dropTitle: "I-drop dito ang CSV file",
    dropActive: "Bitawan para i-upload",
    dropHint: "UTF-8, hanggang {{size}} MB at {{rows}} hanay. Ang unang hanay ay ang mga pangalan ng column.",
    choose: "Pumili ng CSV file",
    chooseLabel: "Pumili ng CSV file para sa {{kind}}",
    reading: "Binabasa ang {{name}}…",
    fileDetails: "{{rows}} hanay · {{columns}} column · {{size}} · UTF-8",
    remove: "Alisin ang file",
    removed: "Naalis ang file. Walang na-import.",
    template: "I-download ang template ng {{kind}}",
    templateDone: "Na-download ang template",
    columns: "Mga column: {{columns}}",
    noteTitle: "Wala pang naisusulat.",
    noteBody: "Ang Hakbang 3 ay dry run na sinusuri ang bawat hanay. Ang mga hanay na tugma sa umiiral na record ay ina-update; ang iba ay nililikha.",
    rejected: {
      type: "Hindi CSV file ang “{{name}}”. I-save ang spreadsheet bilang CSV (UTF-8) at subukan muli.",
      size: "Masyadong malaki ang “{{name}}”. Ang limitasyon ay {{size}} MB.",
      empty: "Walang laman ang “{{name}}”.",
      count: "Isang file lang ang piliin sa bawat pagkakataon.",
    },
  },
  fields: {
    organisations: {
      name: "Pangalan",
      display_code: "Code",
      kind: "Uri",
      industry: "Industriya",
      tier: "Tier",
      email_domains: "Mga e-mail domain",
      tin: "Tax ID",
      external_id: "External ID",
      external_source: "Pinagmulan ng external ID",
      account_manager_email: "E-mail ng account manager",
      billing_address: "Billing address",
      shipping_address: "Shipping address",
    },
    contacts: {
      name: "Pangalan",
      email: "E-mail",
      mobile: "Mobile",
      job_title: "Posisyon",
      organisation: "Organisasyon",
      org_role: "Papel sa organisasyon",
      visibility: "Visibility ng ticket",
      can_order: "Puwedeng umorder",
      order_limit_php: "Limitasyon sa order (PHP)",
      can_approve_orders: "Puwedeng mag-apruba ng order",
      language: "Wika",
    },
    tickets: {
      external_id: "Ticket ID sa lumang sistema",
      external_source: "Pangalan ng lumang sistema",
      title: "Pamagat",
      description: "Paglalarawan",
      status: "Status",
      priority: "Priyoridad",
      type: "Uri ng ticket",
      created_at: "Ginawa",
      updated_at: "Huling na-update",
      resolved_at: "Nairesolba",
      closed_at: "Isinara",
      requester_email: "E-mail ng humiling",
      requester_external_id: "ID ng humiling sa lumang sistema",
      organisation: "Organisasyon",
      assignee_email: "E-mail ng nakatalaga",
      tags: "Mga tag",
      resolution_note: "Tala ng resolusyon",
      messages: "Mga mensahe (JSON)",
      sla_timers: "Simulan ang SLA timer",
    },
  },
  map: {
    intro: "Itinugma namin ang mga pangalan ng column hangga't kaya. Suriin ang bawat isa; may * ang mga kailangang field.",
    caption: "Pagmamapa ng column",
    columnInFile: "Column sa file mo",
    firstRows: "Unang mga hanay",
    goesInto: "Mapupunta sa",
    ignore: "Huwag pansinin ang column na ito",
    fieldFor: "Field para sa column na {{column}}",
    missing: "I-map ang mga kailangang field: {{fields}}.",
    duplicate: "Ang {{fields}} ay naka-map mula sa higit sa isang column. Pumili ng isa.",
    remember: "Tandaan ang pagmamapang ito para sa susunod na file",
    empty: "(walang laman)",
  },
  validate: {
    checking: "Sinusuri ang bawat hanay…",
    checkingHint: "Medyo matagal ito para sa malaking file. Wala pang nase-save.",
    summary: "Resulta ng dry run",
    rows: "Mga hanay sa file",
    rowsSub: "sa file",
    create: "Lilikhain",
    createSub: "mga bagong record",
    update: "Ia-update",
    updateSub: "mga umiiral na record",
    unchanged: "Napapanahon na",
    unchangedSub: "walang babaguhin",
    errors: "Mga error sa hanay",
    errorsNone: "wala",
    errorsSome: "lalaktawan maliban kung maayos",
    errorsTitle_one: "{{count}} error sa hanay",
    errorsTitle_other: "{{count}} error sa mga hanay",
    errorsCaption: "Mga error sa hanay",
    showing: "Ipinapakita ang unang {{shown}} error. I-download ang file para sa buong listahan.",
    row: "Hanay",
    rowN: "Hanay {{row}}",
    column: "Column",
    value: "Halaga",
    problem: "Problema",
    emptyValue: "(walang laman)",
    download: "I-download ang mga error (CSV)",
    downloaded: "Na-download ang mga error sa hanay",
    allPassed: "Pumasa ang bawat hanay. Puwede ka nang mag-import.",
    nothingChanges: "Walang magbabago: tugma na ang bawat hanay sa isang record. Puwede kang magsimulang muli gamit ang ibang file.",
    skip_one: "I-import ang mga wastong hanay ({{valid}}) at laktawan ang hanay na may error. I-download ang error file para ayusin at i-upload ito mamaya.",
    skip_other: "I-import ang mga wastong hanay ({{valid}}) at laktawan ang {{count}} hanay na may error. I-download ang error file para ayusin at i-upload ang mga ito mamaya.",
  },
  done: {
    runningTitle: "Import {{file}}",
    running: "Tumatakbo",
    progressLabel: "Progreso ng import",
    progressText: "{{done}} sa {{total}} hanay",
    completed: "Tapos na",
    failed: "Nabigo ang import",
    cancelled: "Kinansela ang import",
    report: "Ulat ng import",
    created: "Nilikha",
    createdSub: "mga bagong record",
    updated: "In-update",
    updatedSub: "mga umiiral na record",
    unchanged: "Walang binago",
    unchangedSub: "napapanahon na",
    skipped: "Nilaktawan",
    skippedSub: "mga hanay na may error",
    duration: "Tagal",
    durationValue: "{{seconds}} s",
    audit: "Naitala sa audit log ng import job na {{id}}.",
    verifyNote: "Hindi pa verified ang mga na-import na contact: magve-verify sila sa e-mail o magic link sa unang paggamit nila ng portal.",
    openOrganisations: "Buksan ang mga organisasyon",
    openContacts: "Buksan ang mga contact",
    downloadSkipped_one: "I-download ang nilaktawang hanay",
    downloadSkipped_other: "I-download ang {{count}} nilaktawang hanay",
    another: "Mag-import ng ibang file",
    failedTitle: "Hindi natapos ang import",
    failedBody: "Nananatili ang mga hanay na na-save bago ito huminto. Ligtas patakbuhin muli ang parehong file: hindi ginagalaw ang mga hanay na tugma na.",
    cancelledTitle: "Kinansela ang import na ito",
    cancelledBody: "Nabura ang na-upload na file. Nananatili ang mga hanay na na-save na ng import.",
    startOver: "Magsimula ng bagong import",
    empty: { title: "Wala pang import na tumakbo", body: "Magsimula sa CSV file, suriin ito sa dry run, tapos mag-import." },
  },
  actions: {
    back: "Bumalik",
    nextMap: "Susunod: I-map ang mga column",
    nextValidate: "Susunod: I-validate",
    import_one: "I-import ang {{count}} hanay",
    import_other: "I-import ang {{count}} hanay",
    footer: "Mga aksyon sa import",
  },
  states: {
    loadTitle: "Hindi ma-load ang import service",
    loadBody: "Walang binago. Tingnan ang koneksyon mo at subukan muli.",
    retry: "Subukan muli",
    noAccessTitle: "Hindi ka puwedeng mag-import ng mga record",
    noAccessBody: "Kailangan ng pahintulot na mamahala ng mga organisasyon para mag-import. Hilingin sa workspace admin na idagdag ito sa papel mo.",
    failedStep: "Hindi natuloy ang hakbang na iyon. Walang binago.",
  },
  rejections: {
    not_utf8: "Hindi UTF-8 ang file (may mga sirang character). I-export itong muli bilang CSV (UTF-8).",
    not_csv: "Mukhang hindi ito CSV file. I-save ang spreadsheet bilang CSV (UTF-8).",
    empty_file: "Walang laman ang file.",
    no_rows: "Walang hanay ng datos ang file. Ang unang hanay ay dapat ang mga pangalan ng column, sinusundan ng kahit isang hanay.",
    too_many_rows: "Mahigit {{rows}} hanay ang file. Ang limitasyon ay {{rows}} bawat file.",
    too_many_columns: "Mahigit {{columns}} column ang file.",
    cell_too_large: "Masyadong malaki ang isang cell sa file para maging totoong halaga.",
    file_too_large: "Mas malaki sa {{size}} MB ang file. Ang limitasyon ay {{size}} MB.",
    kind_unavailable: "Hindi available ang ganitong import para sa workspace mo.",
    mapping_unknown_column: "May column sa mapping na wala sa file.",
    mapping_unknown_field: "May field sa mapping na hindi umiiral.",
    mapping_duplicate_field: "Higit sa isang column ang naka-map sa iisang field.",
    mapping_missing_required: "I-map ang bawat kailangang field bago suriin ang file.",
    import_not_ready: "Hindi pa handa ang import na ito para sa hakbang na iyon. I-reload ang page para makita kung nasaan ito.",
    import_has_errors: "May mga error sa hanay ang file. Ayusin ang mga ito, o piliing laktawan ang mga hanay na may error.",
    import_nothing_to_import: "Walang wastong hanay na ii-import.",
    import_ended: "Tapos na ang import na ito.",
    import_expired: "Hindi na naka-store ang na-upload na file. I-upload itong muli.",
    import_no_errors: "Walang error sa hanay ang import na ito.",
  },
} as const;
